import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label", "data-chart-type"]
const _hoisted_2 = { class: "mb-3 text-xs font-medium uppercase tracking-wider text-[#737373]" }
const _hoisted_3 = {
  key: 0,
  class: "touch-pan-x overflow-x-auto"
}
const _hoisted_4 = { class: "min-w-[640px]" }
const _hoisted_5 = {
  key: 2,
  class: "rounded-lg bg-[#F7F9F9] p-4 text-sm text-[#626468]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: "aura-chart-block min-w-0 rounded-xl border border-[#E5E5E5] bg-white p-4",
    "aria-label": $props.chart.title || 'Visualização dos dados',
    "data-chart-type": $setup.chartType
  }, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString($setup.chartTitle), 1 /* TEXT */),
    (!$setup.shouldUseTable && $props.chart.status === 'complete')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createBlock($setup["UiChart"], {
              key: $setup.chartRenderKey,
              option: $setup.chartOption,
              height: $setup.chartHeight,
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('select', $event)))
            }, null, 8 /* PROPS */, ["option", "height"]))
          ])
        ]))
      : ($setup.tableRows.length > 0 || ($setup.labels.length > 0 && $setup.data.length > 0))
        ? (_openBlock(), _createBlock($setup["AuraChartTable"], {
            key: 1,
            labels: $setup.labels,
            data: $setup.data,
            columns: $setup.tableColumns,
            "table-rows": $setup.tableRows,
            unit: $props.chart.unit,
            "selected-label": $props.selectedLabel,
            onSelect: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('select', { name: $event })))
          }, null, 8 /* PROPS */, ["labels", "data", "columns", "table-rows", "unit", "selected-label"]))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, " Não há dados suficientes para exibir esta visualização. "))
  ], 8 /* PROPS */, _hoisted_1))
}